const routes = {
  MAIN_CONTENT: {
    component: () => import('@/layout/components/MainContent' /* webpackChunkName: "Route.MainContent", webpackPrefetch: 0 */),
  },
}

export default routes
